import React, { Component } from "react";
import Footer from "../../components/Footer.jsx";
import TranslationText from "../../components/Translation/TranslationText.jsx";
import AuthService from "components/services/AuthService.js";
import webTools from "components/tools/webTools.js";
import RimiLogoHeaderButton from "components/components/HeaderComponents/RimiLogoHeaderButton.jsx";
import * as constants from "../../constants/constants.jsx";
import PhysicalCardConfirmationService from "components/services/PhysicalCardConfirmationService.js";
import { PhysicalCardEntry } from "components/components/Cards/PhysicalCardEntry.jsx";
import { LogoutIcon } from "components/icons/LogoutIcon.jsx";
import { ClappingHandsIcon } from "components/icons/ClappingHandsIcon.jsx";
import { withTranslation } from "react-i18next";

class Congratulations extends Component {

  state = {
    card: {
      cardPrefix: "",
      cardNumber: ""
    },
    errorMessage: ""
  };

  redirectUser() {
    if (sessionStorage.getItem(constants.OIDC_QUERY_KEY)) {
			webTools.reloadToRoute();
		} else {
      webTools.reloadToRoute("ProfileInformation");
		}
  }

	continueClicked = async e => {   
    const { card } = this.state;
    if (card.cardNumber?.length > 0) { 
      await this.attemptToActivateCard();
    } else {
      this.redirectUser();    
    }
	}
  
  attemptToActivateCard = async () => {
    const { card } = this.state;
    let error = "";
    if (!PhysicalCardConfirmationService.isCardFormatValid(card.cardPrefix, card.cardNumber)) {
      error = "card_replacement_page_incorrect_card_number_error";
    }
    else {      
      this.setState({ activateButtonEnabled: false });

      const result = await PhysicalCardConfirmationService.confirmPhysicalCard(card.cardPrefix, card.cardNumber);
      
      this.setState({ activateButtonEnabled: true });
      
      if (result.isConfirmed) {
          this.redirectUser();        
      }
      else {
        error = result.error;
      }
    }    
    this.setState({ errorMessage: error });
  }

  onChange = (card) =>{
    this.setState({ card });
  };

  logout = () => {
    AuthService.logout();
  }

  render() {
    const { errorMessage } = this.state;
    return <React.Fragment>
      <div className="container">
        <div className="card">
          <header className="card-header">
            <RimiLogoHeaderButton initialData={this.props.initialData} />
            <a onClick={this.logout} className="button -secondary -with-right-icon">
              <TranslationText text='logout_button_label' />
              <LogoutIcon />
            </a>
          </header>
          <div className="card-content">
            <div className="single-message">
              <div className="icon">
                <ClappingHandsIcon />
              </div>
              <h1>
                <TranslationText text='account_created_page_congratulations' />
              </h1>
              <p>
                <TranslationText text='account_created_page_info' />
              </p>
            </div>
            
          </div>
            <div className="card-content">
              <div>
                <p>
                  <TranslationText text='account_created_page_activation_instructions_top' />
                </p>
                <PhysicalCardEntry initialData={this.props.initialData} errorMessage={errorMessage} 
                  onChange={this.onChange} />
            </div>
            <p>
              <TranslationText text="account_created_page_activation_instructions_bottom" />              
            </p>
            <div className="form-button full-width">
              <button
                type="submit"
                onClick={this.continueClicked.bind(this)}
                className="button"
                disabled={this.props.isProcessing}
              >                
                <TranslationText text="add_your_data_page_continue_btn" />
              </button>
            </div>
          </div>
          
        </div>
      </div>
      <Footer countrySelectionEnabled={false} />
    </React.Fragment>
  }
}

export default withTranslation()(Congratulations);
